var _g, _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup13(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2076_137)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#E2E31F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8817 26.8366C31.7391 24.8312 29.9549 23.2687 27.8164 22.4005C28.8799 21.6029 29.6654 20.491 30.0618 19.2221C30.4581 17.9533 30.4452 16.5919 30.0248 15.3308C29.6045 14.0697 28.798 12.9728 27.7196 12.1955C26.6412 11.4183 25.3456 11 24.0162 11C22.6869 11 21.3913 11.4183 20.3129 12.1955C19.2345 12.9728 18.428 14.0697 18.0076 15.3308C17.5873 16.5919 17.5744 17.9533 17.9707 19.2221C18.3671 20.491 19.1526 21.6029 20.2161 22.4005C18.0776 23.2687 16.2934 24.8312 15.1508 26.8366C15.08 26.9504 15.0328 27.0773 15.0121 27.2098C14.9913 27.3422 14.9974 27.4775 15.0299 27.6075C15.0625 27.7376 15.1208 27.8597 15.2016 27.9668C15.2823 28.0738 15.3837 28.1635 15.4998 28.2306C15.6158 28.2977 15.7442 28.3407 15.8773 28.3572C16.0103 28.3736 16.1453 28.3632 16.2742 28.3264C16.4032 28.2897 16.5234 28.2274 16.6277 28.1432C16.7321 28.0591 16.8185 27.9548 16.8817 27.8366C18.3918 25.2265 21.0586 23.6698 24.0162 23.6698C26.9739 23.6698 29.6407 25.2273 31.1507 27.8366C31.2878 28.0571 31.5053 28.2156 31.7571 28.2786C32.009 28.3416 32.2755 28.3043 32.5002 28.1744C32.725 28.0445 32.8905 27.8323 32.9617 27.5827C33.0329 27.333 33.0042 27.0654 32.8817 26.8366ZM19.6827 17.3361C19.6827 16.479 19.9369 15.6412 20.413 14.9285C20.8892 14.2159 21.566 13.6605 22.3579 13.3325C23.1497 13.0045 24.021 12.9186 24.8617 13.0859C25.7023 13.2531 26.4745 13.6658 27.0805 14.2719C27.6866 14.8779 28.0993 15.6501 28.2665 16.4907C28.4337 17.3313 28.3479 18.2026 28.0199 18.9945C27.6919 19.7863 27.1365 20.4632 26.4238 20.9393C25.7112 21.4155 24.8733 21.6697 24.0162 21.6697C22.8673 21.6683 21.7658 21.2113 20.9534 20.3989C20.141 19.5865 19.684 18.485 19.6827 17.3361Z",
    fill: "black"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 35,
    r: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 34.9999C42 35.1272 41.9494 35.2493 41.8594 35.3393C41.7694 35.4293 41.6473 35.4799 41.52 35.4799H38.48V38.5199C38.48 38.6472 38.4294 38.7693 38.3394 38.8593C38.2494 38.9493 38.1273 38.9999 38 38.9999C37.8727 38.9999 37.7506 38.9493 37.6606 38.8593C37.5706 38.7693 37.52 38.6472 37.52 38.5199V35.4799H34.48C34.3527 35.4799 34.2306 35.4293 34.1406 35.3393C34.0506 35.2493 34 35.1272 34 34.9999C34 34.8726 34.0506 34.7505 34.1406 34.6605C34.2306 34.5704 34.3527 34.5199 34.48 34.5199H37.52V31.4799C37.52 31.3526 37.5706 31.2305 37.6606 31.1405C37.7506 31.0504 37.8727 30.9999 38 30.9999C38.1273 30.9999 38.2494 31.0504 38.3394 31.1405C38.4294 31.2305 38.48 31.3526 38.48 31.4799V34.5199H41.52C41.6473 34.5199 41.7694 34.5704 41.8594 34.6605C41.9494 34.7505 42 34.8726 42 34.9999Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2076_137",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2076_137"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2076_137",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup13);
export default __webpack_public_path__ + "static/media/Group 13.c813f6a7c36e7950dd2753cd8add31c2.svg";
export { ForwardRef as ReactComponent };